"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const contexts_1 = require("../contexts");
const Explanation_1 = __importDefault(require("../Explanation"));
const RuleLink_1 = require("../RuleLink");
const common_1 = require("./common");
function Recalcul({ nodeValue, explanation, unit, }) {
    const engine = react_1.useContext(contexts_1.EngineContext);
    if (!engine) {
        throw new Error();
    }
    const recalculEngine = engine
        .shallowCopy()
        .setSituation(explanation.parsedSituation);
    react_1.useContext(contexts_1.RegisterEngineContext)(recalculEngine);
    return (jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "recalcul", value: nodeValue, unit: unit }, { children: jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [explanation.recalcul && (jsx_runtime_1.jsx(contexts_1.EngineContext.Provider, Object.assign({ value: recalculEngine }, { children: jsx_runtime_1.jsxs(contexts_1.SituationMetaContext.Provider, Object.assign({ value: {
                            name: 'Mécanisme recalcul',
                        } }, { children: ["Recalcul de la valeur de", ' ', jsx_runtime_1.jsx(Explanation_1.default, { node: explanation.recalcul }, void 0), " avec la situation suivante :"] }), void 0) }), void 0)), jsx_runtime_1.jsx("ul", { children: explanation.amendedSituation.map(([origin, replacement]) => (jsx_runtime_1.jsxs("li", { children: [jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, { dottedName: origin.dottedName }, void 0), " =", ' ', jsx_runtime_1.jsx(Explanation_1.default, { node: replacement }, void 0)] }, origin.dottedName))) }, void 0)] }, void 0) }), void 0));
}
exports.default = Recalcul;
